/* 🎨 STYLES */
import { Container } from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../util/validate";

const Button = ({id, icon, iconPosition = "left", text, child, ...props}) => {
    const width = isValidaProp(props.width) && props.width;
    const onClick = isValidaProp(props.onClick) ? props.onClick : () => console.log('Sem função ao click');
    const disabled = isValidaProp(props.disabled) ? props.disabled : false;

    return(
        <Container 
            id={id} 
            onClick={() => onClick()} 
            disabled={disabled} 
            $borderRadius={props.radius}
            $color={props.color ? props.color : 'gradienteGreen'} 
            $height={props.height}
            $padding={props.padding} 
            $position={props.position}
            $float={props.float}
            $width={width} 
        >
            {icon && iconPosition === "left" && icon}
            {text && <span>{text}</span>}
            {icon && iconPosition === "right" && icon}
            {child ? child : <></>}
        </Container>
    )
}

export default Button;
